<template>
  <div
    class="card-tag-item"
    :class="{ 'safari-hidden': isSafari }"
  >
    <div
      v-if="!displayCardPopover || !tooltip"
      class="card-tag-wrap pt"
      @mousemove="mouseMoveHandler"
      @mouseleave="mouseLeaveHandler"
    >
      <CardTagContent
        :name="name"
        :show-name="showName"
        :icon="tagIconStyle"
      />
      <em
        v-if="showName && showRemoveIcon"
        class="custom-icons remove-icon"
        :style="getCustomIconStyle(iconPath('x'))"
        @click="handleClick"
      />
    </div>
    <v-popover
      v-else
      class="card-tag-wrap pt"
      :content-class="'card-tag-tooltip'"
      :disabled="!tooltip"
      :delay="{ show: 300, hide: 100 }"
      @on-hide="mouseLeaveHandler"
    >
      <CardTagContent
        :name="name"
        :show-name="showName"
        :icon="tagIconStyle"
        @click="handleTagClick"
      />
      <em
        v-if="showName && showRemoveIcon"
        class="custom-icons remove-icon"
        :style="getCustomIconStyle(iconPath('x'))"
        @click="handleClick"
      />
      <template #content="{ state }">
        <div
          v-if="state.isVisible"
          class="tag-popover"
        >
          <em
            :style="tagIconStyle"
            class="custom-icons tags-icon"
            :class="{ small: !showName }"
          />
          <span>{{ name }}</span>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
import CardTagContent from '@/components/functional/CardTagContent';
import useIsBrowser from '@/utilities/composables/useIsBrowser';
import useCustomIcon from '@/utilities/composables/useCustomIcon';

export default {
  name: 'CardTag',
  components: {
    CardTagContent,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    tooltip: {
      type: Boolean,
      required: false,
      default: true,
    },
    showName: {
      type: Boolean,
      required: false,
      default: false,
    },
    showRemoveIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    quickCard: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['remove-tag', 'click'],

  setup() {
    const { isSafari } = useIsBrowser();
    const { getCustomIconStyle, iconPath } = useCustomIcon();

    return {
      isSafari,
      getCustomIconStyle,
      iconPath,
    };
  },

  data() {
    return {
      displayCardPopover: false,
      displayCardPopoverTimeout: null,
    };
  },

  computed: {
    tagIconStyle() {
      return {
        ...this.getCustomIconStyle(this.iconPath('tag')),
        backgroundColor: this.color,
      };
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.quickCard) {
        this.setTagPopover();
      }
    });
  },

  unmounted() {
    clearTimeout(this.displayCardPopoverTimeout);
  },
  methods: {
    handleClick() {
      this.$emit('remove-tag');
    },
    setTagPopover() {
      this.displayCardPopoverTimeout = setTimeout(() => {
        this.displayCardPopover = true;
      }, 30);
    },
    removePopover() {
      clearTimeout(this.displayCardPopoverTimeout);
      this.displayCardPopover = false;
    },

    handleTagClick() {
      this.$emit('click');
    },

    mouseMoveHandler() {
      if (this.quickCard) return;
      this.setTagPopover();
    },

    mouseLeaveHandler() {
      if (this.quickCard) return;
      this.removePopover();
    },
  },
};
</script>
